import styled from '@emotion/styled';

// hooks
import { useGetProductCategoryFetch } from '@hooks/fetch/useProductFetch';

// components
import CategoryItem from './CategoryItem';

// constants
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';

// type
import LoadingSpinner from '@components/_atoms/LoadingSpinner';

type Props = {
  product_type_id: number;
  standardCodeId: number;
  standardCode: string;
};

const LoadingSpinnerWrapper = styled.div`
  margin-top: 250px;

  @media ${MOBILE_MODE} {
    margin-top: 120px;
  }
`;

const Layout = styled.div`
  display: grid;
  justify-content: space-around;
  grid-template-columns: repeat(auto-fill, 252px);
  gap: 24px;

  @media ${TABLET_MODE} {
    grid-template-columns: repeat(auto-fill, 216px);
    gap: 20px;
  }

  @media ${MOBILE_MODE} {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export default function CategoryList({ product_type_id, standardCodeId, standardCode }: Props) {
  const { getProductCategoryFetchData: categoryData, isCustomLoading } = useGetProductCategoryFetch(
    product_type_id,
    standardCode,
  );

  return (
    <>
      {isCustomLoading ? (
        <LoadingSpinnerWrapper>
          <LoadingSpinner />
        </LoadingSpinnerWrapper>
      ) : (
        <Layout>
          {categoryData?.map((item, index) => (
            <CategoryItem
              data={item}
              key={index}
              product_type={product_type_id}
              standardCodeId={standardCodeId}
              standardCode={standardCode}
            />
          ))}
        </Layout>
      )}
    </>
  );
}
